module.exports = __webpack_public_path__ + "img/ekr.69c06c30.png";